/* eslint jsx-a11y/no-redundant-roles: 0 */
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Paragraph } from '@scentregroup/ui'
import { occurrencesType } from '../../../types'
import { summariseOccurrences } from '../../../helpers/occurrences'
import PotentialLink from '../../potential-link'
import ResponsiveImage from '../../responsive-image'
import Trackable from '../../trackable'
import { trackingActions, trackingTypes } from '../../../constants'
import style from './index.scss'

const DeckCard = ({
  className,
  body,
  title,
  image,
  link,
  externalLink,
  occurrences,
  location,
  onClick,
  analyticsMetadata,
}) => {
  const hasOccurrences = Boolean(
    occurrences && occurrences.times && occurrences.times.length
  )
  return (
    <li
      className={classNames(style.DeckCard, className)}
      role="listitem"
      data-test-id="card"
    >
      <Trackable
        {...analyticsMetadata}
        trackingAction={trackingActions.viewPromotion}
        type={trackingTypes.promotion}
        creative={analyticsMetadata?.promotion?.creative}
      >
        <PotentialLink
          link={link}
          className={style.link}
          external={externalLink}
          onClick={onClick}
        >
          <ResponsiveImage
            className={style.image}
            desktopImageUrl={image}
            mobileImageUrl={image}
            mobileRatio="square"
            desktopRatio="square"
            numberOfItems={4}
            alt=""
            dataTestId="card-image"
          />
          <div className={style.cardBody}>
            <div className={style.cardInner} data-test-id="card-details">
              <Paragraph className={style.title}>{title}</Paragraph>
              {(hasOccurrences || location) && (
                <div className={style.metaWrapper}>
                  {hasOccurrences && (
                    <Paragraph className={style.meta}>
                      {summariseOccurrences(
                        occurrences.times,
                        occurrences.timeZone
                      )}
                    </Paragraph>
                  )}
                  {location && (
                    <Paragraph className={style.meta}>{location}</Paragraph>
                  )}
                </div>
              )}
              <Paragraph type="large" className={style.description}>
                {body}
              </Paragraph>
            </div>
          </div>
        </PotentialLink>
      </Trackable>
    </li>
  )
}

DeckCard.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  link: PropTypes.string,
  externalLink: PropTypes.bool,
  occurrences: occurrencesType,
  location: PropTypes.string,
  onClick: PropTypes.func,
  analyticsMetadata: PropTypes.shape({
    correlationId: PropTypes.string,
    title: PropTypes.string,
    promotion: PropTypes.shape({
      creative: PropTypes.string,
    }),
  }),
}

export default DeckCard
